(function () {
  "use strict";
  function isLikelyBot() {
    try {
      if (window.Shopify && window.Shopify.designMode) return !1;
      if (navigator.webdriver) return !0;
      var ua = navigator.userAgent;
      return !!(
        /HeadlessChrome|PhantomJS|SlimerJS|Selenium|Puppeteer|Playwright/i.test(
          ua,
        ) ||
        !window.history ||
        !document.querySelector ||
        !document.addEventListener ||
        navigator.cookieEnabled === !1 ||
        window.screen.width === 0 ||
        window.screen.height === 0 ||
        (document.visibilityState && document.visibilityState !== "visible")
      );
    } catch {
      return !1;
    }
  }

  const CONFIG = window.SWISH_SHELF_CONFIG || {};
  const BASIC_TEE = {
    key: "basic-tee",
    label: "Basic Tee",
    suffix: "-basic-tee",
    category: "Tees",
    price: 24,
    enable_custom_request: true,
    default_variants: {
      options: ["Color", "Size"],
      colors: ["Black", "Navy", "Dark Heather", "White", "Red", "Royal", "Heather Royal", "Charcoal", "Daisy", "Light Blue", "Sport Grey"],
      sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    },
    blurb: "A soft, straightforward everyday tee at an easy price.",
    fabric: "Soft ringspun cotton, midweight and smooth.",
    fit: "Unisex regular fit. True to size; size up for a relaxed look.",
  };
  function withBasicTee(data) {
    data = data || {};
    data.variants = Array.isArray(data.variants) ? data.variants.slice() : [];
    const index = data.variants.findIndex((v) => v && v.key === BASIC_TEE.key);
    if (index === -1) data.variants.push(BASIC_TEE);
    else data.variants[index] = {
      ...BASIC_TEE,
      ...data.variants[index],
      key: "basic-tee",
      label: "Basic Tee",
      suffix: "-basic-tee",
      price: 24,
      enable_custom_request: true,
    };
    data.prices = { ...(data.prices || {}), "basic-tee": 24 };
    data.productTypeMappings = {
      ...(data.productTypeMappings || {}),
      "Basic TEE": "basic-tee",
    };
    return data;
  }
  try {
    if (!document.getElementById("sw-shelf-inline-style")) {
      const st = document.createElement("style");
      ((st.id = "sw-shelf-inline-style"),
        (st.textContent =
          ".sw-urgency-inline .sw-info-i{opacity:0.9 !important;}"),
        document.head.appendChild(st));
    }
  } catch {}
  const CNY = {
      cottonKeys: ["cotton-long-sleeve-button-shirt", "cotton-button-shirt"],
      seasonEnd: new Date("2026-02-19"),
      cutoffCotton: new Date("2026-01-31T23:59:59"),
      cutoffPoly: new Date("2026-02-06T23:59:59"),
      resumeCotton: new Date("2026-02-24"),
      resumePoly: new Date("2026-02-24"),
    },
    Engine = {
      isPostCutoff: !1,
      applyFormat: function (v, isUpgradeLabel) {
        var discountEl = document.getElementById("global-sale-percentage"),
          discount =
            discountEl && discountEl.value ? parseFloat(discountEl.value) : 0,
          rawFormat = decodeURIComponent(CONFIG.format),
          formatMoney = function (cents) {
            var str = rawFormat.replace(
                /\{\{\s*(\w+)\s*\}\}/,
                (cents / 100).toFixed(2),
              ),
              tmp = document.createElement("DIV");
            return (
              (tmp.innerHTML = str),
              tmp.textContent || tmp.innerText || ""
            );
          };
        if (discount > 0) {
          var originalPrice = formatMoney(v),
            discountedValue = v * (1 - discount / 100),
            salePrice = formatMoney(discountedValue);
          return isUpgradeLabel
            ? salePrice
            : `<span style="color: #D8176A; font-weight: 900;">${salePrice}</span> <span style="text-decoration: line-through; color: #94a3b8; font-size: 0.85em; font-weight: 400; margin-left: 4px;">${originalPrice}</span>`;
        }
        return formatMoney(v);
      },
      getMkt: () => {
        const h = location.hostname.toLowerCase(),
          cur =
            window.Shopify && Shopify.currency && Shopify.currency.active
              ? Shopify.currency.active
              : "USD";
        return h.includes(".ca") || cur === "CAD"
          ? "CA"
          : h.includes(".co.uk") || cur === "GBP"
            ? "UK"
            : h.includes(".eu") || cur === "EUR"
              ? "EU"
              : h.includes("australia") || cur === "AUD"
                ? "AU"
                : "US";
      },
      checkCutoff: (mkt) => {
        const h = {
            US: "America/Los_Angeles",
            CA: "America/Los_Angeles",
            UK: "Europe/London",
            EU: "Europe/Riga",
            AU: "Australia/Brisbane",
          },
          tz = h[mkt] || h.US,
          now = new Date(),
          hubTime = new Date(now.toLocaleString("en-US", { timeZone: tz })),
          cutoff = new Date(now.toLocaleString("en-US", { timeZone: tz }));
        return (cutoff.setHours(12, 0, 0, 0), hubTime > cutoff);
      },
      addBD: (date, days) => {
        let result = new Date(date),
          count = 0;
        for (; count < days;)
          (result.setDate(result.getDate() + 1),
            result.getDay() !== 0 && result.getDay() !== 6 && count++);
        return result;
      },
      AVAIL_KEY_MAP: {
        "t-shirt": "T-Shirt",
        "tank-top": "Tank Top",
        hoodie: "Hoodie",
        sweatshirt: "Sweatshirt",
        "triblend-t-shirt": "Triblend T-Shirt",
        "text-shirt": "Text Shirt",
        "boxy-t-shirt": "Boxy T-Shirt",
        "basic-tee": "Basic TEE",
        mug: "Mug",
        "muscle-shirt": "Muscle Shirt",
      },
      isAvailableForRequest: (v, mkt, availData) => {
        if (mkt === "US" || !availData || !availData.products) return !0;
        const availKey = Engine.AVAIL_KEY_MAP[v.key];
        if (!availKey) return !0;
        const entry = availData.products[availKey]
          || (v.key === "basic-tee" ? availData.products["Daily Dozen"] : null);
        if (!entry) return !0;
        const marketEntry = entry[mkt.toLowerCase()];
        if (!marketEntry) return !1;
        const colors = marketEntry.Color || {};
        return Object.values(colors).some(
          (sizes) => Array.isArray(sizes) && sizes.length > 0,
        );
      },
      lookupPrice: (v, prices) => {
        if (!prices) return null;
        if (prices[v.key] != null) return prices[v.key];
        const stripped = v.key.replace(/-/g, "");
        if (prices[stripped] != null) return prices[stripped];
        const aliases = {
          "t-shirt": "tshirt",
          "tank-top": "tanktop",
          "triblend-t-shirt": "triblend",
          "crop-top": "croptop",
          "boxy-t-shirt": "boxytee",
          "aop-sweatpants": "sweats",
          "aop-union-suit": "onesie",
          "fleece-jacket": "fleece",
          "fleece-hoodie": "fleece",
          "aop-hoodie": "hoodie",
          "allover-t-shirt": "tshirt",
          "allover-tank-top": "tanktop",
          "womens-t-shirt": "womens",
          "swim-briefs": "swimsuit",
          "swim-trunks": "swimsuit",
          "square-cut-trunks": "swimsuit",
          "cotton-button-shirt": "buttonshirt",
          "long-sleeve-button-shirt": "buttonshirt",
          "cotton-long-sleeve-button-shirt": "buttonshirt",
          "folding-fans": "handfan",
          "pet-shirt": "pets",
          "pet-hoodie": "pets",
          "tote-bag": "tote",
        };
        return aliases[v.key] && prices[aliases[v.key]] != null
          ? prices[aliases[v.key]]
          : null;
      },
      fireDebut: (variant, params) => {
        if (typeof window.swishDebutFire == "function") {
          window.swishDebutFire({
            design: params.get("design"),
            designTitle: params.get("from_title"),
            target: params.get("target"),
            targetLabel: params.get("target_label"),
            fromId: params.get("from_id"),
            fromTitle: params.get("from_title"),
            mockup: params.get("mockup"),
            sourceHandle:
              (window.location.pathname.match(/^\/products\/([^\/?#]+)/) ||
                [])[1] || null,
          });
          return;
        }
        location.href = `/pages/custom-product?${params.toString()}`;
      },
      showDebutConfirm: (variant, params, data) => {
        const modal = document.getElementById("swish-debut-confirm-modal");
        if (!modal) {
          Engine.fireDebut(variant, params);
          return;
        }
        document.body.appendChild(modal);
        const price = Engine.lookupPrice(variant, data.prices),
          priceEl = document.getElementById("swish-debut-confirm-price");
        priceEl &&
          price != null &&
          (priceEl.innerHTML = Engine.applyFormat(price * 100));
        const cleanName = (CONFIG.productTitle || "")
            .replace(/\s*\([^)]*\)\s*$/, "")
            .trim(),
          nameEl = document.getElementById("swish-debut-confirm-name");
        nameEl && (nameEl.textContent = `${cleanName} (${variant.label})`);
        const prodDays = variant.delivery && variant.delivery.production,
          deliveryEl = document.getElementById("swish-debut-confirm-delivery");
        deliveryEl &&
          (deliveryEl.textContent =
            prodDays && prodDays.min != null && prodDays.max != null
              ? `Made to order. ${prodDays.min} to ${prodDays.max} business days to produce.`
              : "Made to order");
        const blurbEl = document.getElementById("swish-debut-confirm-blurb");
        blurbEl &&
          (blurbEl.textContent = `Create ${cleanName || "this design"} as a ${variant.label}. Choose your options and review the price when it is ready.`);
        const metaEl = document.getElementById("swish-debut-confirm-meta");
        metaEl &&
          !metaEl.textContent.trim() &&
          (metaEl.textContent =
            "Usually under a minute. Up to 5 if the queue is busy. Keep browsing; we'll ping you in the corner when it's ready.");
        const ensureStash = () => {
            let stash = document.getElementById("swish-modal-stash");
            return (
              stash ||
                ((stash = document.createElement("div")),
                (stash.id = "swish-modal-stash"),
                (stash.style.cssText =
                  "display:none !important;visibility:hidden !important;position:absolute;left:-9999px;top:-9999px;"),
                stash.setAttribute("aria-hidden", "true"),
                document.body.appendChild(stash)),
              stash
            );
          },
          close = () => {
            try {
              (modal.style.setProperty("display", "none", "important"),
                modal.style.setProperty("visibility", "hidden", "important"),
                modal.style.setProperty("opacity", "0", "important"),
                modal.style.setProperty("pointer-events", "none", "important"),
                modal.setAttribute("aria-hidden", "true"),
                modal.setAttribute("hidden", "hidden"),
                ensureStash().appendChild(modal));
            } catch {}
            document.body.style.overflow = "";
            document.querySelector(".sw-studio__open")?.focus({preventScroll:true});
          },
          go = () => {
            (close(), Engine.fireDebut(variant, params));
          },
          freshClone = (id) => {
            const el = document.getElementById(id);
            if (!el || !el.parentElement) return el;
            const clone = el.cloneNode(!0);
            return (el.parentElement.replaceChild(clone, el), clone);
          },
          cancelBtn = freshClone("swish-debut-confirm-cancel"),
          goBtn = freshClone("swish-debut-confirm-go");
        const heading = modal.querySelector("h3");
        if (heading) {
          heading.textContent = `${cleanName} · ${variant.label}`;
          if (heading.previousElementSibling) heading.previousElementSibling.hidden = true;
        }
        [blurbEl, metaEl, nameEl, deliveryEl].forEach(el => { if (el) el.hidden = true; });
        if (priceEl) {
          if (priceEl.previousElementSibling) priceEl.previousElementSibling.hidden = true;
          priceEl.parentElement.style.display = "block";
          priceEl.style.cssText = "display:block;font-size:20px;font-weight:800;color:#1e293b;line-height:1.4;overflow-wrap:anywhere";
        }
        if (goBtn) goBtn.textContent = "Create " + variant.label;
        if (cancelBtn) cancelBtn.textContent = "Cancel";
        let alreadyFired = !1;
        const fireOnce = (fn) => (e) => {
          if (alreadyFired) {
            e && (e.preventDefault(), e.stopPropagation());
            return;
          }
          ((alreadyFired = !0), fn());
        };
        (cancelBtn && (cancelBtn.onclick = fireOnce(close)),
          goBtn && (goBtn.onclick = fireOnce(go)),
          (modal.onclick = (e) => {
            document
              .getElementById("swish-debut-confirm-content")
              .contains(e.target) || close();
          }),
          modal.style.removeProperty("display"),
          modal.style.removeProperty("visibility"),
          modal.style.removeProperty("opacity"),
          modal.style.removeProperty("pointer-events"),
          modal.removeAttribute("aria-hidden"),
          modal.removeAttribute("hidden"),
          (modal.style.display = "block"),
          (document.body.style.overflow = "hidden"));
      },
      repositionTitle: () => {
        try {
          // Keep media first on mobile. Native block order keeps the purchase
          // controls, including Sezzle, in the information column.
          return;
        } catch {}
      },
      init: async () => {
        try {
          const [menuRes, availRes] = await Promise.all([
              fetch(CONFIG.jsonUrl),
              fetch(CONFIG.availJsonUrl).catch(() => null),
            ]),
            data = withBasicTee(await menuRes.json()),
            availData = availRes
              ? await availRes.json().catch(() => null)
              : null,
            mkt = Engine.getMkt(),
            key =
              (data.productTypeMappings &&
                data.productTypeMappings[CONFIG.type]) ||
              CONFIG.type.toLowerCase().replace(/\s+/g, "-"),
            v = data.variants.find((item) => item.key === key);
          if (!v) return;
          ((Engine.isPostCutoff = Engine.checkCutoff(mkt)),
            CONFIG.type === "Daily Dozen" &&
              CONFIG.isEnglish &&
              Engine.initTimer(mkt, v, data),
            Engine.renderTrustRow(data, v, mkt),
            Engine.renderAA(data, key, mkt, availData));
        } catch (e) {
          console.error("Swish Engine Error:", e);
          window.SwishFormatStudio?.empty();
        }
      },
      initTimer: (mkt, v, data) => {
        if (v.key === "gildan-softstyle-tee" || CONFIG.type === "Daily Dozen") {
          const lbl = document.getElementById("sw-urgency-label");
          lbl &&
            (lbl.innerHTML =
              'Vanishes in <span id="sw-countdown" class="sw-digits"></span>');
          const tt = document.getElementById("sw-timer-tooltip-text");
          tt &&
            (tt.innerText =
              "Get it while you can. This design leaves the lineup at the 3 AM ET drop and won't be buyable after that. Once it's gone, it's gone.");
          const runDD = () => {
            const nyNow = new Date(
                new Date().toLocaleString("en-US", {
                  timeZone: "America/New_York",
                }),
              ),
              drop = new Date(nyNow);
            (drop.setHours(3, 0, 0, 0),
              nyNow >= drop && drop.setDate(drop.getDate() + 1));
            const diff = drop - nyNow,
              h_ = Math.floor(diff / 36e5)
                .toString()
                .padStart(2, "0"),
              m_ = Math.floor((diff % 36e5) / 6e4)
                .toString()
                .padStart(2, "0"),
              s_ = Math.floor((diff % 6e4) / 1e3)
                .toString()
                .padStart(2, "0"),
              cdEl = document.getElementById("sw-countdown");
            cdEl && (cdEl.innerText = `${h_}:${m_}:${s_}`);
            const el = document.getElementById("sw-urgency-inline");
            el && (el.style.display = "flex");
          };
          (setInterval(runDD, 1e3), runDD());
          return;
        }
        const originRaw = v.delivery && v.delivery.origin,
          origin = (originRaw && (originRaw[mkt] || originRaw.US)) || "USA";
        let isCNYMode = !1,
          targetDate = null;
        if (origin === "China") {
          const now = new Date();
          if (now <= CNY.seasonEnd) {
            const activeCutoff = CNY.cottonKeys.includes(v.key)
                ? CNY.cutoffCotton
                : CNY.cutoffPoly,
              warningStart = new Date(activeCutoff);
            if (
              (warningStart.setDate(warningStart.getDate() - 4),
              now >= warningStart && now < activeCutoff)
            ) {
              ((isCNYMode = !0), (targetDate = activeCutoff));
              const lbl = document.getElementById("sw-urgency-label");
              lbl &&
                (lbl.innerHTML =
                  'Cut-off before factory break in <span id="sw-countdown" class="sw-digits"></span>');
              const tt = document.getElementById("sw-timer-tooltip-text");
              tt &&
                (tt.innerText =
                  "This product is imported from overseas and many suppliers close for the Lunar New Year.");
            }
          }
        }
        const run = () => {
          const h = {
              US: "America/Los_Angeles",
              CA: "America/Los_Angeles",
              UK: "Europe/London",
              EU: "Europe/Riga",
              AU: "Australia/Brisbane",
            },
            tz = h[mkt] || h.US,
            now = new Date(),
            hubTime = new Date(now.toLocaleString("en-US", { timeZone: tz }));
          let cutoff;
          isCNYMode
            ? (cutoff = new Date(targetDate))
            : ((cutoff = new Date(
                now.toLocaleString("en-US", { timeZone: tz }),
              )),
              cutoff.setHours(12, 0, 0, 0),
              hubTime > cutoff && cutoff.setDate(cutoff.getDate() + 1));
          const diff = cutoff - hubTime;
          let displayStr = "00:00:00";
          if (diff > 0)
            if (isCNYMode && diff > 864e5)
              displayStr = `${Math.ceil(diff / 864e5)} Days`;
            else {
              const h_ = Math.floor(diff / 36e5)
                  .toString()
                  .padStart(2, "0"),
                m_ = Math.floor((diff % 36e5) / 6e4)
                  .toString()
                  .padStart(2, "0"),
                s_ = Math.floor((diff % 6e4) / 1e3)
                  .toString()
                  .padStart(2, "0");
              displayStr = `${h_}:${m_}:${s_}`;
            }
          else ((displayStr = "00:00:00"), isCNYMode && location.reload());
          const cdEl = document.getElementById("sw-countdown");
          if ((cdEl && (cdEl.innerText = displayStr), !isCNYMode)) {
            const lbl = document.getElementById("sw-urgency-label");
            lbl &&
              (lbl.innerHTML = Engine.isPostCutoff
                ? `Order in <span id="sw-countdown" class="sw-digits">${displayStr}</span> for tomorrow's batch`
                : `Order in <span id="sw-countdown" class="sw-digits">${displayStr}</span> for today's batch`);
          }
          const el = document.getElementById("sw-urgency-inline");
          el && (el.style.display = "flex");
        };
        (setInterval(run, 1e3), run());
      },
      renderTrustRow: (data, v, mkt) => {
        const row = document.getElementById("sw-trust-row");
        if (!row) return;
        const originRaw = v.delivery && v.delivery.origin,
          origin = (originRaw && (originRaw[mkt] || originRaw.US)) || "USA",
          isLocal =
            origin ===
            { US: "USA", CA: "Canada", UK: "UK", EU: "EU", AU: "Australia" }[
              mkt
            ],
          fmt = (d) =>
            d.toLocaleString("en-US", { month: "short", day: "numeric" }),
          p = v.delivery.production,
          ship = isLocal
            ? data.deliveryDefaults.shippingDays.same_country
            : data.deliveryDefaults.shippingDays.different_country;
        let baseDate = new Date();
        Engine.isPostCutoff && baseDate.setDate(baseDate.getDate() + 1);
        let truckIcon = CONFIG.cdn + "shipping-truck.svg",
          arrivalStartDate = new Date(baseDate);
        const alertBox = document.getElementById("sw-cny-alert");
        if (
          (alertBox && (alertBox.style.display = "none"),
          origin === "China" && baseDate <= CNY.seasonEnd)
        ) {
          const isCottonList = CNY.cottonKeys.includes(v.key),
            activeCutoff = isCottonList ? CNY.cutoffCotton : CNY.cutoffPoly,
            activeResume = isCottonList ? CNY.resumeCotton : CNY.resumePoly;
          baseDate > activeCutoff &&
            alertBox &&
            ((alertBox.innerHTML = `<strong>&#x1F9E7; Holiday Production Pause</strong> This product is affected by the Lunar New Year closure and will resume production on ${activeResume.toLocaleDateString("en-US", { month: "short", day: "numeric" })}.`),
            (alertBox.style.display = "block"),
            (arrivalStartDate = new Date(activeResume)),
            (truckIcon = CONFIG.cdn + "late.svg"));
        }
        const totalDaysMin = parseInt(p.min) + parseInt(ship.min),
          totalDaysMax = parseInt(p.max) + parseInt(ship.max),
          arrivalMinStr = fmt(
            Engine.addBD(new Date(arrivalStartDate), totalDaysMin),
          ),
          arrivalMaxStr = fmt(
            Engine.addBD(new Date(arrivalStartDate), totalDaysMax),
          ),
          arrivalText = `${arrivalMinStr} to ${arrivalMaxStr}`;
        try {
          const swForm = document.querySelector('form[action*="/cart/add"]');
          if (swForm) {
            let swProp = swForm.querySelector(
              'input[name="properties[Estimated delivery]"]',
            );
            (swProp ||
              ((swProp = document.createElement("input")),
              (swProp.type = "hidden"),
              (swProp.name = "properties[Estimated delivery]"),
              swForm.appendChild(swProp)),
              (swProp.value = `${arrivalMinStr} to ${arrivalMaxStr}`));
          }
        } catch {}
        let fulfillmentLabel, fulfillmentIcon;
        if (isLocal)
          ((fulfillmentIcon =
            CONFIG.cdn +
            (data.originIconMappings?.[mkt]?.[origin.toLowerCase()] ||
              "location-pin.svg")),
            (fulfillmentLabel =
              {
                US: "Ships from USA",
                CA: "Ships from Canada",
                UK: "Ships from UK",
                EU: "Ships from EU",
                AU: "Ships from Australia",
              }[mkt] || "Ships Locally"));
        else {
          fulfillmentIcon = CONFIG.cdn + "global.svg";
          let label = "Duties Prepaid";
          ((CONFIG.type || "").toLowerCase().indexOf("leather") !== -1 &&
            (mkt === "UK" || mkt === "EU") &&
            (label = "VAT & Duty May Apply"),
            (fulfillmentLabel = label));
        }
        let gpsrHtml = "";
        if (mkt === "EU") {
          let g;
          origin === "EU"
            ? (g = {
                who: "Sinden Ventures Limited",
                addr: "AMarkou Evgenikou 11<br>Mesa Geitonia 4002 Limassol, Cyprus",
                email: "gpsr@sindenventures.com",
              })
            : origin === "China"
              ? (g = {
                  who: "Europe Gateway International B.V.",
                  addr: "Kraijenhoffstraat 137 A<br>1018RG Amsterdam, Netherlands",
                  email: "info@euegi.nl",
                })
              : (g = {
                  who: "Swish Embassy Inc.",
                  addr: "2967 Dundas St. W. #1366<br>Toronto, ON M6P 1Z2, Canada",
                  email: "",
                });
          const emailLine = g.email
            ? `<br><a href="mailto:${g.email}">${g.email}</a>`
            : "";
          gpsrHtml =
            '<span class="sw-gpsr" tabindex="0" role="button" aria-label="EU product safety responsible person: ' +
            g.who +
            '">GPSR<span class="sw-gpsr-tip" role="tooltip"><strong>EU Responsible Person</strong>' +
            g.who +
            "<br>" +
            g.addr +
            emailLine +
            "</span></span>";
        }
        let withdrawalHtml = "";
        mkt === "EU" &&
          (withdrawalHtml = `<span class="sw-gpsr" tabindex="0" role="button" aria-label="Notification for EU consumers: right of withdrawal">Returns<span class="sw-gpsr-tip" role="tooltip"><strong>Notification for EU consumers</strong>According to Article 16(c) and (e) of the Directive 2011/83/EU of the European Parliament and of the Council of 25 October 2011 on consumer rights, the right of withdrawal may not be provided for:<br>1. the supply of goods that are made to the consumer's specifications or are clearly personalized;<br>2. sealed goods which were unsealed after delivery and thus aren't suitable for return due to health protection or hygiene reasons,<br>therefore Swish Embassy reserves rights to refuse returns at its sole discretion.</span></span>`);
        const complianceHtml =
          gpsrHtml || withdrawalHtml
            ? `<span class="sw-trust-compliance">${gpsrHtml}${withdrawalHtml}</span>`
            : "";
        const ratingEl = document.getElementById("jdgm-rating"),
          reviewsEl = document.getElementById("jdgm-reviews"),
          categoryRatingEl = document.getElementById("swish-category-rating"),
          categoryReviewsEl = document.getElementById("swish-category-reviews"),
          shopRatingEl = document.getElementById("swish-shop-rating"),
          shopReviewsEl = document.getElementById("swish-shop-reviews"),
          ratingSourceEl = document.getElementById("swish-rating-source"),
          productRating = ratingEl ? parseFloat(ratingEl.value) : 0,
          productReviewCount = reviewsEl ? parseInt(reviewsEl.value, 10) : 0,
          categoryRating = categoryRatingEl ? parseFloat(categoryRatingEl.value) : 0,
          categoryReviewCount = categoryReviewsEl ? parseInt(categoryReviewsEl.value, 10) : 0,
          shopRating = shopRatingEl ? parseFloat(shopRatingEl.value) : 0,
          shopReviewCount = shopReviewsEl ? parseInt(shopReviewsEl.value, 10) : 0,
          useCategoryReviews = categoryReviewCount > 0 && categoryRating > 0,
          useProductReviews = productReviewCount > 0 && productRating > 0,
          useShopReviews = shopReviewCount > 0 && shopRating > 0,
          displayRating = useCategoryReviews ? categoryRating : (useProductReviews ? productRating : (useShopReviews ? shopRating : 0)),
          displayReviewCount = useCategoryReviews ? categoryReviewCount : (useProductReviews ? productReviewCount : (useShopReviews ? shopReviewCount : 0)),
          ratingSource = useCategoryReviews ? (ratingSourceEl?.value || "category") : (useProductReviews ? "product" : "Judge.me shop"),
          ratingHref = "/pages/reviews",
          pills = [];
        const originLabel = {
          Canada: "🇨🇦 Ships from Canada",
          China: "Imported",
          USA: "🇺🇸 Ships from USA",
          EU: "🇪🇺 Ships from EU",
          UK: "🇬🇧 Ships from UK",
          Australia: "🇦🇺 Ships from Australia",
          Mexico: "🇲🇽 Ships from Mexico",
          Germany: "🇩🇪 Ships from Germany",
          Spain: "🇪🇸 Ships from Spain",
          Poland: "🇵🇱 Ships from Poland",
          Latvia: "🇱🇻 Ships from Latvia",
          Netherlands: "🇳🇱 Ships from Netherlands",
          Italy: "🇮🇹 Ships from Italy",
          Czechia: "🇨🇿 Ships from Czechia",
          Turkey: "🇹🇷 Ships from Turkey",
          Brazil: "🇧🇷 Ships from Brazil",
          Japan: "🇯🇵 Ships from Japan",
          "South Korea": "🇰🇷 Ships from South Korea",
          India: "🇮🇳 Ships from India",
        }[origin] || `Ships from ${origin}`;
        pills.push(
          `<span class="sw-pill sw-pill--green"><span class="sw-trust-delivery"><img src="${truckIcon}" alt=""><span class="sw-trust-copy">Delivered <span class="sw-trust-arrival">${arrivalText}</span>.</span></span><span class="sw-trust-origin">${originLabel}</span>${complianceHtml}</span>`,
        );
        if (displayRating > 0) pills.push(
          `<a class="sw-pill sw-pill--link" href="${ratingHref}" aria-label="${displayReviewCount} reviews, ${ratingSource} rating">&#9733; ${displayRating.toFixed(1)}<span style="color:#94a3b8;font-weight:500;">/5${displayReviewCount > 0 ? " (" + displayReviewCount + ")" : ""}</span></a>`,
        );
        if (!isLocal && fulfillmentLabel)
          pills.push(
            `<span class="sw-pill"><img src="${fulfillmentIcon}" alt=""> ${fulfillmentLabel}${complianceHtml}</span>`,
          );
        v.fit &&
          pills.push(
            `<button type="button" class="sw-pill sw-pill--link sw-fit-trigger" data-open="size-modal" aria-label="Open size chart"><svg class="sw-pill-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21.3 8.7L8.7 21.3a2.4 2.4 0 0 1-3.4 0L2.7 18.7a2.4 2.4 0 0 1 0-3.4L15.3 2.7a2.4 2.4 0 0 1 3.4 0l2.6 2.6a2.4 2.4 0 0 1 0 3.4Z"/><path d="m7.5 10.5 2 2"/><path d="m10.5 7.5 2 2"/><path d="m13.5 4.5 2 2"/><path d="m4.5 13.5 2 2"/></svg> Fit: ${v.fit} <span class="sw-pill-chevron" aria-hidden="true">&rsaquo;</span></button>`,
          );
        row.innerHTML = pills.join("");
        row.classList.toggle("sw-trust-row--no-duties", !(!isLocal && fulfillmentLabel));
        row.style.display = "grid";
        try {
          var badges = row.querySelectorAll(".sw-gpsr");
          badges.forEach(function (badge) {
            var tip = badge.querySelector(".sw-gpsr-tip");
            if (!tip) return;
            var hoverTimer = null;
            function position() {
              var b = badge.getBoundingClientRect(),
                tipRect = tip.getBoundingClientRect(),
                tipW = tipRect.width || 240,
                tipH = tipRect.height || 90,
                margin = 10,
                above = b.top - tipH - margin,
                below = b.bottom + margin,
                top = above >= 8 ? above : below;
              badge.classList.toggle("is-below", top === below);
              var left = b.left + b.width / 2 - tipW / 2;
              ((left = Math.max(
                8,
                Math.min(left, window.innerWidth - tipW - 8),
              )),
                (tip.style.top = top + "px"),
                (tip.style.left = left + "px"));
              var arrowX = b.left + b.width / 2 - left;
              ((arrowX = Math.max(12, Math.min(arrowX, tipW - 12))),
                tip.style.setProperty("--arrow-x", arrowX + "px"));
            }
            function open() {
              (clearTimeout(hoverTimer),
                badge.classList.add("is-open"),
                position());
            }
            function close() {
              hoverTimer = setTimeout(function () {
                badge.classList.remove("is-open");
              }, 150);
            }
            (badge.addEventListener("mouseenter", open),
              badge.addEventListener("mouseleave", close),
              badge.addEventListener("focus", open),
              badge.addEventListener("blur", close),
              tip.addEventListener("mouseenter", open),
              tip.addEventListener("mouseleave", close));
          });
        } catch {}
      },
      renderAA: async (data, curKey, mkt, availData) => {
        const host = document.getElementById("swish-format-studio");
        if (!host || !window.SwishFormatStudio) return;
        try {const api=await window.SwishMarketReady();await api.ready;}catch{window.SwishMarketFailure(host,()=>Engine.renderAA(data,curKey,mkt,availData));return;}
        const filtered = data.variants.filter(
          (v) => v.key !== curKey && v.hidden_on_alternates !== !0,
        );
        let marketError=false;
        let base = CONFIG.handle;
        [...data.variants]
          .sort((a, b) => (b.suffix || "").length - (a.suffix || "").length)
          .forEach((vr) => {
            vr.suffix &&
              base.endsWith(vr.suffix) &&
              (base = base.replace(vr.suffix, ""));
          });
        let baseExists = !1, baseResponse = null;
        try {
          baseResponse = await fetch(`${CONFIG.root || "/"}products/${base}.js`, {
            cache: "no-store",
          });
          baseExists = baseResponse.ok;
        } catch {
          baseExists = !1;
        }
        // Mug and coaster pages are not in the Debut index: their garment
        // Debut cards show the base design's art, so the preview applet looks
        // up the base product (same stripped handle) instead of this page.
        if (baseExists && base !== CONFIG.handle && (curKey === "mug" || curKey === "coaster") && window.SWISH_DEBUT_PREVIEW) {
          try {
            const id = String((await baseResponse.json()).id);
            if (/^[1-9][0-9]{0,15}$/.test(id)) window.SWISH_DEBUT_PREVIEW.designProductId = id;
          } catch {}
        }
        const estimatePrice = async v => {
          try {
            let handle = v.key === "basic-tee" ? "rolling-basic-tee" : null;
            if (!handle) {
              const type = Object.keys(data.productTypeMappings || {}).find(t => data.productTypeMappings[t] === v.key);
              if (!type) return null;
              const query = new URLSearchParams({q:type,"resources[type]":"product","resources[limit]":"10","resources[options][fields]":"product_type","resources[options][unavailable_products]":"hide"});
              const response = await fetch(`${CONFIG.root || "/"}search/suggest.json?${query}`, {signal:AbortSignal.timeout(5000)});
              if (!response.ok) return null;
              const products = (await response.json()).resources?.results?.products || [];
              handle = products.find(p => data.productTypeMappings[p.type || p.product_type] === v.key)?.handle;
            }
            if (!handle) return null;
            const response = await fetch(`${CONFIG.root || "/"}products/${encodeURIComponent(handle)}.js`, {signal:AbortSignal.timeout(5000)});
            if (!response.ok) return null;
            const raw = await response.json();
            if (data.productTypeMappings[raw.type] !== v.key) return null;
            const product = await (await window.SwishMarketReady()).apply(raw);
            const prices = product.variants.filter(v => v.available && Number.isFinite(v.price) && v.price > 0).map(v => v.price);
            return prices.length ? {cents:Math.min(...prices),reference:handle} : null;
          } catch { return null; }
        };
        const items = (
          await window.SwishFormatStudio.mapLimit(filtered, 6, async (v) => {
            const url = `${CONFIG.root || "/"}products/${base}${v.suffix || ""}`;
            let product = null, missing = false;
            try {
              const r = await fetch(url + ".js", {signal: AbortSignal.timeout(8000)});
              missing = r.status === 404;
              r.ok && (product = await (await window.SwishMarketReady()).apply(await r.json()));
            } catch {marketError=true;}
            return product && product.featured_image != null
              ? { v, url, kind: "real", product }
              : !missing || !baseExists ||
                  (data.settings &&
                    data.settings.customRequestEnabled === !1) ||
                  !v.enable_custom_request ||
                  !Engine.isAvailableForRequest(v, mkt, availData)
                ? null
                : { v, url, kind: "debut", product: null, estimate: await estimatePrice(v) };
          })
        ).filter(Boolean);
        // Include the current garment so comparison always preserves the shopper's starting point.
        const currentFormat = data.variants.find(v => v.key === curKey);
        if (currentFormat) {
          try {
            const currentUrl = `${CONFIG.root || "/"}products/${CONFIG.handle}`;
            const response = await fetch(currentUrl + ".js");
            if (response.ok) {
              const product = await (await window.SwishMarketReady()).apply(await response.json());
              items.unshift({v: currentFormat, url: currentUrl, kind: "real", product, isCurrent: true});
            }
          } catch {}
        }
        if(marketError)window.SwishMarketFailure(host,()=>Engine.renderAA(data,curKey,mkt,availData));
        if (items.length === 0) {
          window.SwishFormatStudio.empty();
          return;
        }
        const RANK = data.shelfRanking || {},
          MARGINS = (data.profitability && data.profitability.margins) || {},
          nowMonth = new Date().getMonth() + 1;
        function shelfScore(v) {
          let s = (RANK.volume && RANK.volume[v.key]) || 1;
          ((s *= 1 + (RANK.marginWeight || 0) * (MARGINS[v.key] || 0)),
            RANK.newTypeBoost &&
              RANK.newTypeBoost[v.key] &&
              (s *= RANK.newTypeBoost[v.key]));
          for (const season of Object.values(RANK.seasonal || {}))
            season.months &&
              season.months.indexOf(nowMonth) !== -1 &&
              season.boost &&
              season.boost[v.key] &&
              (s *= season.boost[v.key]);
          return (
            RANK.upgradeBoost &&
              (RANK.upgradeBoost.from || []).indexOf(curKey) !== -1 &&
              RANK.upgradeBoost.types &&
              RANK.upgradeBoost.types[v.key] &&
              (s *= RANK.upgradeBoost.types[v.key]),
            s
          );
        }
        items.sort((a, b) =>
          a.kind !== b.kind
            ? a.kind === "real"
              ? -1
              : 1
            : shelfScore(b.v) - shelfScore(a.v),
        );
        window.SwishFormatStudio.mount({
          items,
          current: curKey,
          config: CONFIG,
          create: (item) => {
            const params = new URLSearchParams({
              design: base,
              from: CONFIG.handle,
              from_id: CONFIG.productId,
              from_title: CONFIG.productTitle,
              target: item.v.key,
              target_label: item.v.label,
              mockup: CONFIG.featuredImage || "",
            });
            Engine.showDebutConfirm(item.v, params, data);
            const price = document.getElementById("swish-debut-confirm-price");
            if (price) price.textContent = item.estimate
              ? window.SwishFormatStudio.estimateText(item)
              : CONFIG.labels.confirmed_price;
            const modal = document.getElementById("swish-debut-confirm-modal");
            if (modal) {
              modal.setAttribute("role", "dialog");
              modal.setAttribute("aria-modal", "true");
              modal.setAttribute("aria-label", CONFIG.labels.create);
            }
            document.getElementById("swish-debut-confirm-cancel")?.focus();
          },
        });
      },
    };
  (Engine.init(),
    (function () {
      const findThemeOpener = () => {
        const openers = document.querySelectorAll("modal-opener");
        for (const o of openers) {
          const btn = o.querySelector("button, a"),
            t = ((btn && btn.textContent) || "").trim().toLowerCase();
          if (
            t === "size chart" ||
            t === "size guide" ||
            t.includes("size chart") ||
            t.includes("size guide")
          )
            return btn;
        }
        const dlgs = document.querySelectorAll("modal-dialog");
        for (const d of dlgs)
          if (/size\s*(chart|guide)/i.test(d.textContent || "")) {
            const id = d.id,
              opener = document.querySelector(
                `modal-opener[data-modal="${id}"] button, modal-opener[data-modal="${id}"] a`,
              );
            if (opener) return opener;
          }
        return null;
      };
      document.addEventListener("click", (e) => {
        if (!(e.target.closest && e.target.closest('[data-open="size-modal"]')))
          return;
        e.preventDefault();
        const opener = findThemeOpener();
        if (opener) {
          opener.click();
          return;
        }
        window.location.href = "/pages/size-chart";
      });
    })());
})();